<template>
  <div class="main-cell">
    <div :class="vAlignClasses()">
      <responsive-background
        :desktop="payload.image"
        :mobile="payload.mobileImage"
        class="background"
      />
      <div :class="hAlignClasses()">
        <p
          v-if="payload.overtitle"
          :style="{'color' : payload.color}"
          class="h6 overtitle"
        >{{payload.overtitle ? payload.overtitle : category}}</p>
        <p v-else-if="category" :style="{'color' : payload.color}" class="h6 overtitle">{{category}}</p>
        <p :style="{'color' : payload.color}" class="h1 title">{{payload.abstract}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      default: null
    },
    payload: {
      default: {}
    }
  },

  mounted() {
    this.payload.align = this.payload.align || "middle-left";
  },
  data() {
    return {
      vAlignClasses: () => {
        if (this.payload && this.payload.align) {
          return `hero-component-grid grid-x align-top align-${
            this.payload.align.split("-")[0]
          }`;
        }
        // default
        return `hero-component-grid grid-x align-top align-bottom`;
      },
      hAlignClasses: () => {
        if (this.payload && this.payload.align) {
          const pos = this.payload.align.split("-")[1];

          if (pos === "right") {
            return "cell small-12 large-6 large-offset-6";
          } else if (pos === "center") {
            return "cell small-12 large-6 large-offset-3";
          } else {
            return "cell small-12 large-6 large-offset-0";
          }
        }
        // default
        return "cell small-12 large-6 large-offset-1";
      },
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.main-cell {
  .hero-component-grid {
    overflow: hidden;

    @include breakpoint(large up) {
      height: calc(100vh - 128px);
      margin: 0;
    }

    @include breakpoint(medium down) {
      height: 100vh;
      padding: 0;
    }
    @include breakpoint(small only) {
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: flex-end;
    }

    position: relative;
    z-index: 1;
    .background {
      z-index: -1;
      background-size: cover;
      background-position: center;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
    }
    .cell {
      padding: 128px;
      @include breakpoint(large up) {
        margin: 0;
      }
      @include breakpoint(medium down) {
        width: 100%;
        padding: 0 32px 64px;
      }
      p {
        font-weight: $global-weight-bold;
        margin-bottom: 0;
        & + p {
          margin-top: 16px;
        }
        &.overtitle {
          text-transform: uppercase;
          @include breakpoint(small only) {
            font-size: 1.2rem;
          }
        }
        &.title {
          @include breakpoint(small only) {
            font-size: 2rem;
          }
        }
        &.readmore {
          margin-top: 32px;
          a {
            font-size: 18px;
            line-height: 20px;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>

